/* Auto Worx site links: WhatsApp opens the app on phones; Book, Free plan and Free estimate buttons (and any Shopmonkey
   booking or quote-request link) open the on-site sheet. Loaded after awx-book.js. */
(function () {
  'use strict';
  var d = document, w = window;
  var mq = function (q) { return !!(w.matchMedia && w.matchMedia(q).matches); };
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || !e.target.closest) return;
    /* WhatsApp: same tab on phones, so the WhatsApp app takes over instead of leaving a stray tab */
    var wa = e.target.closest('a[href*="wa.me/"],a[href*="api.whatsapp.com/"]');
    if (wa && !wa.hasAttribute('data-awx-open')) { if (mq('(pointer: coarse)')) wa.removeAttribute('target'); return; }
    var B = w.AWXBook; if (!B) return;
    var a = e.target.closest('[data-awx-open],a[href*="shopmonkey.cloud/public/scheduler/"],a[href*="shopmonkey.cloud/public/quote-request/"]');
    if (!a || a.closest('[data-awx-sheet]') || a.hasAttribute('data-awx-fallback') || a.getAttribute('aria-disabled') === 'true') return;
    var href = a.getAttribute('href') || '';
    var flow = a.getAttribute('data-awx-open') || (/quote-request/.test(href) ? 'estimate' : 'book');
    var svc = a.getAttribute('data-svc'), shop = a.getAttribute('data-shop') || B.shopFromHref(href);
    if (flow === 'book' && !B.api) {
      /* booking relay not switched on yet: a button for one service picks it in the booking card on the home page */
      if (!svc) return;
      var card = d.querySelector('[data-awx-book]');
      if (!card) { try { sessionStorage.setItem('awx-pick', JSON.stringify({ svc: svc })); } catch (x) {} return; }
      if (card.contains(a)) return;
      e.preventDefault();
      card.dispatchEvent(new CustomEvent('awx:pick', { detail: { svc: svc } }));
      (d.getElementById('awx-book') || card).scrollIntoView({ behavior: mq('(prefers-reduced-motion: reduce)') ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    e.preventDefault();
    if (a.hasAttribute('data-awx-cta')) { var c = a.closest('[data-awx-book]'), p = c && c.querySelector('[data-svc][aria-pressed="true"]'); if (p) svc = p.getAttribute('data-svc'); }
    B.open(flow, { svc: svc, shop: shop, tireNote: a.getAttribute('data-tire-note') || '' });   /* tires page: "not sure" / "own tires" links (Nov 2 2026) */
  });
})();
